import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TechHero from '@/components/TechHero';
import TechServicesOverview from '@/components/TechServicesOverview';
import { useSEO } from '@/hooks/useSEO';

const Index = () => {
  // Set SEO for home page with emphasis on free assessment
  useSEO({
    title: "🆓 FREE Digital Assessment | QuantumBox AI",
    description: "Get your FREE Digital Transformation Assessment! Complete analysis + strategic recommendations. 40% faster than competitors, 60% cost reduction.",
    keywords: "free digital transformation assessment, free AI assessment report, digital readiness evaluation, free business assessment, digital transformation consulting, AI business automation, free digital audit, business process assessment, digital maturity evaluation",
    ogTitle: "🆓 FREE Digital Assessment | QuantumBox AI",
    ogDescription: "Get your FREE Digital Transformation Assessment! Complete analysis + strategic recommendations. 40% faster results than competitors, 60% cost reduction. Free assessment report included!",
    canonical: "https://quantumbox.ai"
  });

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <TechHero />
      <TechServicesOverview />
      <Footer />
    </div>
  );
};

export default Index;
